import { render, staticRenderFns } from "./Video.vue?vue&type=template&id=d2bf8b8e&scoped=true&lang=pug&"
import script from "./Video.vue?vue&type=script&lang=js&"
export * from "./Video.vue?vue&type=script&lang=js&"
import style0 from "./Video.styl?vue&type=style&index=0&id=d2bf8b8e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2bf8b8e",
  null
  
)

export default component.exports